<template>
  <div>
    <top-header :type="12" :placeholder="keyWord" @comfirmText="comfirmText" v-if='this.$route.query.type != "wx"'/>
    <top-header :type="10" :placeholder="keyWord" @comfirmText="comfirmText" v-else/>
    <div class="cover_opc" @touchmove.prevent v-show="showCover"></div>
    <div style="text-align:center;padding-top:30%;font-size:16px">
      该功能正在升级中
    </div>
    <div class="wrapper">
      <div class="select_con" v-show="Boolean(projectList.length)">
        <div
          class="m_flex_box flex_vc flex_jz row"
          v-for="(item, index) in projectList"
          :key="index"
        >
          <p class="left line_comp1" @click="setProjectName(item)">
            {{ item.tgmc }}({{ item.xmmc }})
          </p>
        </div>
      </div>
    </div>
    <van-overlay :show="Boolean(projectList.length)"> </van-overlay>
    <div class="tab_con m_flex_box flex_jz" :class="showPad ? 'fixed' : ''" v-if="flase">
      <div class="inner_con">
        <p
          class="text m_flex_box flex_vc flex_hc"
          :class="tab.showArea === true ? 'active' : ''"
          @click="setTab('showArea')"
        >
          <span class="line_comp1">{{
            tabText.showArea ? tabText.showArea : "区域"
          }}</span>
          <van-icon name="play" />
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="inner_list inner_form" v-show="tab.showArea">
            <p
              :class="formData.xzqh === item.xzqh_code ? 'active' : ''"
              @click="
                setVal('xzqh', item.xzqh_code, item.xzqh_name, 'showArea')
              "
              v-for="(item, index) in xzqhArray"
              :key="index"
            >
              {{ item.xzqh_name }}
            </p>
          </div>
        </transition>
      </div>
      <div class="inner_con">
        <p
          class="text m_flex_box flex_vc flex_hc"
          :class="tab.showPrice === true ? 'active' : ''"
          @click="setTab('showPrice')"
        >
          <span class="line_comp1">{{
            tabText.showPrice ? tabText.showPrice : "价格"
          }}</span>
          <van-icon name="play" />
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="price_list inner_form" v-show="tab.showPrice">
            <div class="m_flex_box price_inner">
              <div class="left" @touchmove.prevent>
                <p
                  :class="priceType === 1 ? 'active' : ''"
                  @click="changePrice(1)"
                >
                  单价
                </p>
                <p
                  :class="priceType === 2 ? 'active' : ''"
                  @click="changePrice(2)"
                >
                  总价
                </p>
              </div>
              <div class="right flex-1" v-show="priceType === 1">
                <p
                  :class="formData.price === '' ? 'active' : ''"
                  @click="setVal('price', '', '', 'showPrice')"
                >
                  不限
                </p>
                <div v-show="xzqhDefault === '320300'">
                  <p
                    :class="formData.price === item.value ? 'active' : ''"
                    @click="setVal('price', item.value, item.text, 'showPrice')"
                    v-for="(item, index) in utilPrice"
                    :key="index"
                  >
                    {{ item.text }}
                  </p>
                </div>

                <div v-show="xzqhDefault !== '320300'">
                  <p
                    :class="formData.price === item.value ? 'active' : ''"
                    @click="setVal('price', item.value, item.text, 'showPrice')"
                    v-for="(item, index1) in utilPrice1"
                    :key="index1"
                  >
                    {{ item.text }}
                  </p>
                </div>
              </div>
              <div class="right flex-1" v-show="priceType === 2">
                <p
                  :class="formData.totalPrice === '' ? 'active' : ''"
                  @click="setVal('totalPrice', '', '', 'showPrice')"
                >
                  不限
                </p>
                <div v-show="xzqhDefault === '320300'">
                  <p
                    :class="formData.totalPrice === item.value ? 'active' : ''"
                    @click="
                      setVal('totalPrice', item.value, item.text, 'showPrice')
                    "
                    v-for="(item, index) in totalPrice"
                    :key="index"
                  >
                    {{ item.text }}
                  </p>
                </div>
                <div v-show="xzqhDefault !== '320300'">
                  <p
                    :class="formData.totalPrice === item.value ? 'active' : ''"
                    @click="
                      setVal('totalPrice', item.value, item.text, 'showPrice')
                    "
                    v-for="(item, index1) in totalPrice1"
                    :key="index1"
                  >
                    {{ item.text }}
                  </p>
                </div>
              </div>
            </div>
            <div class="bottom_con m_flex_box flex_vc flex_jz">
              <div class="m_flex_box flex_vc">
                <span class="tit">自定义</span>
                <input type="number" v-model="min" /><i>-</i
                ><input type="number" v-model="max" />
                <p><span v-show="priceType === 2">万</span>元</p>
              </div>
              <van-button type="info" @click="priceConfirm">确定</van-button>
            </div>
          </div>
        </transition>
      </div>
      <div class="inner_con">
        <p
          class="text m_flex_box flex_vc flex_hc"
          :class="tab.showHx === true ? 'active' : ''"
          @click="setTab('showHx')"
        >
          <span class="line_comp1">{{
            tabText.showHx ? tabText.showHx : "户型"
          }}</span>
          <van-icon name="play" />
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="inner_list inner_form" v-show="tab.showHx">
            <p
              :class="formData.hx === '' ? 'active' : ''"
              @click="setVal('hx', '', '', 'showHx')"
            >
              不限
            </p>
            <p
              :class="formData.hx === 1 ? 'active' : ''"
              @click="setVal('hx', 1, '一居室', 'showHx')"
            >
              一居室
            </p>
            <p
              :class="formData.hx === 2 ? 'active' : ''"
              @click="setVal('hx', 2, '二居室', 'showHx')"
            >
              二居室
            </p>
            <p
              :class="formData.hx === 3 ? 'active' : ''"
              @click="setVal('hx', 3, '三居室', 'showHx')"
            >
              三居室
            </p>
            <p
              :class="formData.hx === 4 ? 'active' : ''"
              @click="setVal('hx', 4, '四居室', 'showHx')"
            >
              四居室
            </p>
            <p
              :class="formData.hx === 5 ? 'active' : ''"
              @click="setVal('hx', 5, '五居室', 'showHx')"
            >
              五居室
            </p>
            <p
              :class="formData.hx === 6 ? 'active' : ''"
              @click="setVal('hx', 6, '五居室及以上', 'showHx')"
            >
              五居室及以上
            </p>
          </div>
        </transition>
      </div>
      <div class="inner_con">
        <p
          class="text m_flex_box flex_vc flex_hc"
          :class="tab.showType === true ? 'active' : ''"
          @click="setTab('showType')"
        >
          <span class="line_comp1">更多</span>
          <van-icon name="play" />
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="more_list inner_form" v-show="tab.showType">
            <div class="more_con">
              <div class="row_con">
                <h4>房屋类型</h4>
                <div class="row_inner m_flex_box flex_vc flex_vw">
                  <span
                    :class="formData.lx === '住宅' ? 'active' : ''"
                    @click="setValB('lx', '住宅')"
                    >住宅</span
                  >
                  <span
                    :class="formData.lx === '商服' ? 'active' : ''"
                    @click="setValB('lx', '商服')"
                    >商服</span
                  >
                  <span
                    :class="formData.lx === '办公' ? 'active' : ''"
                    @click="setValB('lx', '办公')"
                    >办公</span
                  >
                  <span
                    :class="formData.lx === '仓储' ? 'active' : ''"
                    @click="setValB('lx', '仓储')"
                    >仓储</span
                  >
                  <span
                    :class="formData.lx === '车库' ? 'active' : ''"
                    @click="setValB('lx', '车库')"
                    >车库</span
                  >
                  <span
                    :class="formData.lx === '储藏室' ? 'active' : ''"
                    @click="setValB('lx', '储藏室')"
                    >储藏室</span
                  >
                  <span
                    :class="formData.lx === '地下室' ? 'active' : ''"
                    @click="setValB('lx', '地下室')"
                    >地下室</span
                  >
                </div>
              </div>
              <div class="row_con">
                <h4>是否有电梯</h4>
                <div class="row_inner m_flex_box flex_vc flex_vw">
                  <span
                    :class="formData.liftMark === 1 ? 'active' : ''"
                    @click="setValB('liftMark', 1)"
                    >是</span
                  >
                  <span
                    :class="formData.liftMark === 0 ? 'active' : ''"
                    @click="setValB('liftMark', 0)"
                    >否</span
                  >
                </div>
              </div>
              <div class="row_con">
                <h4>房屋类型</h4>
                <div class="row_inner m_flex_box flex_vc flex_vw">
                  <span
                    :class="
                      formData.houseAttribute === '商品房' ? 'active' : ''
                    "
                    @click="setValB('houseAttribute', '商品房')"
                    >商品房</span
                  >
                  <span
                    :class="
                      formData.houseAttribute === '经适房' ? 'active' : ''
                    "
                    @click="setValB('houseAttribute', '经适房')"
                    >经适房</span
                  >
                  <span
                    :class="
                      formData.houseAttribute === '定销房' ? 'active' : ''
                    "
                    @click="setValB('houseAttribute', '定销房')"
                    >定销房</span
                  >
                  <span
                    :class="
                      formData.houseAttribute === '动迁房' ? 'active' : ''
                    "
                    @click="setValB('houseAttribute', '动迁房')"
                    >动迁房</span
                  >
                </div>
              </div>
              <div class="row_con">
                <h4>物业类型</h4>
                <div class="row_inner m_flex_box flex_vc flex_vw">
                  <span
                    :class="formData.structType === '多层' ? 'active' : ''"
                    @click="setValB('structType', '多层')"
                    >多层</span
                  >
                  <span
                    :class="formData.structType === '小高层' ? 'active' : ''"
                    @click="setValB('structType', '小高层')"
                    >小高层</span
                  >
                  <span
                    :class="formData.structType === '高层' ? 'active' : ''"
                    @click="setValB('structType', '高层')"
                    >高层</span
                  >
                  <span
                    :class="formData.structType === '洋房' ? 'active' : ''"
                    @click="setValB('structType', '洋房')"
                    >洋房</span
                  >
                  <span
                    :class="formData.structType === '别墅叠拼' ? 'active' : ''"
                    @click="setValB('structType', '别墅叠拼')"
                    >别墅叠拼</span
                  >
                  <span
                    :class="formData.structType === '别墅独栋' ? 'active' : ''"
                    @click="setValB('structType', '别墅独栋')"
                    >别墅独栋</span
                  >
                  <span
                    :class="formData.structType === '别墅联排' ? 'active' : ''"
                    @click="setValB('structType', '别墅联排')"
                    >别墅联排</span
                  >
                  <span
                    :class="formData.structType === '别墅双拼' ? 'active' : ''"
                    @click="setValB('structType', '别墅双拼')"
                    >别墅双拼</span
                  >
                  <span
                    :class="formData.structType === '办公' ? 'active' : ''"
                    @click="setValB('structType', '办公')"
                    >办公</span
                  >
                  <span
                    :class="formData.structType === '写字楼' ? 'active' : ''"
                    @click="setValB('structType', '写字楼')"
                    >写字楼</span
                  >
                  <span
                    :class="formData.structType === '公寓' ? 'active' : ''"
                    @click="setValB('structType', '公寓')"
                    >公寓</span
                  >
                  <span
                    :class="formData.structType === '商铺' ? 'active' : ''"
                    @click="setValB('structType', '商铺')"
                    >商铺</span
                  >
                  <span
                    :class="formData.structType === '商业' ? 'active' : ''"
                    @click="setValB('structType', '商业')"
                    >商业</span
                  >
                </div>
              </div>
            </div>
            <div class="m_flex_box flex_vc flex_jz btn_con">
              <button class="reset" @click="reset">重置</button>
              <button class="confirm" @click="confirm">确定</button>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="map_con" v-if="flase">
      <baidu-map
       
        class="bm-view"
        :center="center"
        :scroll-wheel-zoom="true"
        :zoom="zoom"
        :dragging="dragging"
        @ready="handler"
        @moving="moveMap"
        @zoomend="changeZoom"
        @dragstart="dragstart"
        @dragend="dragend"
      >
        <my-overlay
          v-for="(item, index) in showList"
          :key="index"
          :position="
            zoom <= 12
              ? { lng: item.zb.jd, lat: item.zb.wd }
              : { lng: item.jd, lat: item.wd }
          "
          :info="item"
          :zoom="zoom"
          :check="checkNum"
          @click.native="
            setCheck(
              zoom <= 12
                ? { lng: item.zb.jd, lat: item.zb.wd }
                : { lng: item.jd, lat: item.wd },
              item.itemId,
              item
            )
          "
        >
        </my-overlay>
      </baidu-map>
      <div class="map_bottom" v-if="showInfo">
        <div
          class="row m_flex_box flex_vc"
          @click="toDetail(infoDetail.itemId, infoDetail.old)"
        >
          <img
            v-lazy="imgPath + 'sImgMin/' + infoDetail.xmfm + '.jpg'"
            alt=""
          />
          <div class="right flex_v flex_jz">
            <div class="tit m_flex_box flex_vc flex_jz">
              <h5 class="line_comp1">{{ infoDetail.tgmc }}</h5>
              <i>{{ infoDetail.xsqkStr }}</i>
            </div>
            <p class="address line_comp1">{{ infoDetail.xmdz }}</p>
            <p class="price">
              <span>{{ infoDetail.priceStr }}</span
              >{{ infoDetail.priceStr != "暂无" ? "元/m²" : "" }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="aside" v-if="flase">
      <p>新房</p>
      <router-link to="/oldMap">二手房</router-link>
    </div>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
import MyOverlay from "@/components/myOverLay";
import slideImg from '@/components/slideImg'
export default {
  data() {
    return {
      projectList: [],
      oneList: [],
      twoList: [],
      dragging: false,
      overList: [],
      checkNum: null,
      utilPrice: [
        {
          value: "5000-10000",
          text: "10000元/m²以下",
        },
        {
          value: "10001-15000",
          text: "10001-15000元/m²",
        },
        {
          value: "15001-17000",
          text: "15001-17000元/m²",
        },
        {
          value: "17001-20000",
          text: "17001-20000元/m²",
        },
        {
          value: "20001-25000",
          text: "20001-25000元/m²",
        },
        {
          value: "25001-30000",
          text: "25001-30000元/m²",
        },
        {
          value: "30001-50000",
          text: "30001元/m²以上",
        },
      ],
      utilPrice1: [
        {
          value: "1000-5000",
          text: "5000元/m²以下",
        },
        {
          value: "5001-6000",
          text: "5001-6000元/m²",
        },
        {
          value: "6001-7000",
          text: "6001-7000元/m²",
        },
        {
          value: "7001-8000",
          text: "7001-8000元/m²",
        },
        {
          value: "8001-9000",
          text: "8001-9000元/m²",
        },
        {
          value: "9001-10000",
          text: "9001-10000元/m²",
        },
        {
          value: "10001-20000",
          text: "10000元/m²以上",
        },
      ],
      totalPrice: [
        {
          value: "100000-1000000",
          text: "100万以下",
        },
        {
          value: "1000000-1500000",
          text: "100-150万元",
        },
        {
          value: "1510000-2000000",
          text: "151-200万元",
        },
        {
          value: "2010000-2500000",
          text: "201-250万元",
        },
        {
          value: "2510000-3000000",
          text: "251-300万元",
        },
        {
          value: "3010000-4000000",
          text: "301-400万元",
        },
        {
          value: "4000000-100000000",
          text: "400万以上",
        },
      ],
      totalPrice1: [
        {
          value: "10000-500000",
          text: "50万以下",
        },
        {
          value: "510000-700000",
          text: "51-70万元",
        },
        {
          value: "710000-800000",
          text: "71-80万元",
        },
        {
          value: "810000-900000",
          text: "81-90万元",
        },
        {
          value: "910000-1000000",
          text: "91-100万元",
        },
        {
          value: "1010000-1200000",
          text: "101-120万元",
        },
        {
          value: "1200000-5000000",
          text: "120万以上",
        },
      ],
      tab: {
        showArea: false,
        showPrice: false,
        showHx: false,
        showType: false,
        showSort: false,
      },
      tabText: {
        showArea: "",
        showPrice: "",
        showHx: "",
        showSort: "",
      },
      priceType: 1,
      formData: {
        xzqh: this.main.getHostArea(),
        price: "",
        totalPrice: "",
        xsjgq: "",
        xsjgz: "",
        zjgq: "",
        zjgz: "",
        hx: "",
        lx: "",
        liftMark: "",
        houseAttribute: "",
        structType: "",
        order: 0,
      },
      min: "",
      max: "",
      showPad: false,
      showCover: false,
      xzqhDefault: this.main.getHostArea(),
      xzqhArray: [],
      items: "",
      scale: 1,
      center: { lng: 117.290722, lat: 34.211547 },
      zoom: 12,
      active: true,
      map: null,
      showList: [],
      timer: null,
      showInfo: false,
      infoDetail: {},
      keyWord: "",
    };
  },
  components: {
    topHeader,
    MyOverlay,
    slideImg
  },
  mounted() {
    this.getArea();
  },
  watch: {
    keyWord(n) {
      this.$set(this, "projectList", []);
      const newArr = [];
      this.twoList.forEach(function (item) {
        if (
          (item.tgmc.includes(n) || item.xmmc.includes(n)) &&
          item.old === "0"
        ) {
          newArr.push(item);
        }
      });
      this.$set(this, "projectList", newArr);
      if (n === "") {
        this.$set(this, "projectList", []);
      }
    },
  },
  methods: {
    toDetail(itemId, old) {
      if (this.$route.query.type === "wx") {
        if (old == 1) {
          uni.navigateTo({
            url: `/pages/old/projectDetail?itemId=${itemId}`,
          });
        } else {
          uni.navigateTo({
            url: `/pages/new/detail?itemId=${itemId}`,
          });
        }
      } else {
        var paths = "/projectDetail";
        if (old) {
          if (old !== "0") {
            paths = "/projectDetailIndex";
          }
        } else {
          paths = "/projectDetail";
        }
        this.$router.push({
          path: paths,
          query: { itemId },
        });
      }
    },
    comfirmText(data) {
      this.keyWord = data;
    },
    setCheck(center, id, item) {
      console.log(item);
      this.center = center;
      if (this.zoom <= 12) {
        this.zoom = 16;
      } else {
        this.checkNum = id;
        this.showInfo = true;
        this.infoDetail = item;
      }
    },
    setProjectName(info) {
      this.twoList.forEach((item) => {
        if (item.itemId === info.itemId) {
          this.center = { lng: item.jd, lat: item.wd };
          this.checkNum = info.itemId;
          this.showInfo = true;
          this.infoDetail = item;
        }
      });
      setTimeout(() => {
        this.$set(this, "projectList", []);
        this.getConernPoint();
      }, 10);
    },
    dragstart() {
      this.dragging = true;
    },
    dragend() {
      this.dragging = false;
      // setTimeout(() => {
      // }, 100);
    },
    getFirst() {
      this.$new
        .post("/map/getMaptotal.do", qs.stringify(this.formData))
        .then((res) => {
          this.oneList = res.obj;
          if (this.zoom <= 12) {
            this.overList = res.obj;
          }
          this.$new
            .post("/map/getMapList.do", qs.stringify(this.formData))
            .then((res) => {
              if (this.zoom > 12) {
                this.overList = res.obj;
                if (res.obj.length) {
                  this.center = { lng: res.obj[0].jd, lat: res.obj[0].wd };
                  setTimeout(() => {
                    this.getConernPoint();
                  }, 100);
                }
              }
              this.twoList = res.obj;
              this.getConernPoint();
            });
        });
    },
    changeZoom(type, target) {
      this.zoom = type.target.Za;
      if (this.zoom <= 12) {
        this.showInfo = false;
        this.$set(this, "overList", this.oneList);
      } else {
        this.$set(this, "overList", this.twoList);
      }
      setTimeout(() => {
        this.dragging = false;
      }, 1);
      this.getConernPoint();
    },
    moveMap() {
      this.getConernPoint();
    },
    getConernPoint() {
      return new Promise((resolve) => {
        if (!this.timer) {
          if (this.map) {
            this.map.clearOverlays();
            let minPoint = this.map.getBounds().getSouthWest();
            let maxPoint = this.map.getBounds().getNorthEast();
            const newArr = [];
            if (this.zoom <= 12) {
              this.overList.forEach((item) => {
                if (
                  item.zb.wd <= maxPoint.lat &&
                  item.zb.wd >= minPoint.lat &&
                  item.zb.jd <= maxPoint.lng &&
                  item.zb.jd >= minPoint.lng
                ) {
                  newArr.push(item);
                }
              });
            } else {
              this.overList.forEach((item) => {
                if (
                  item.wd <= maxPoint.lat &&
                  item.wd >= minPoint.lat &&
                  item.jd <= maxPoint.lng &&
                  item.jd >= minPoint.lng
                ) {
                  newArr.push(item);
                }
              });
            }
            this.$set(this, "showList", newArr);
            resolve({ min: minPoint, max: maxPoint });
          }
          this.timer = setTimeout(() => {
            this.timer = null;
          }, 1);
        }
      });
    },
    handler({ BMap, map }) {
      this.map = map;
      this.dragging = true;
      this.getFirst();
    },
    // 获取默认的行政区划
    getArea() {
      this.$new.post("xzqh/getXzqh.do").then((res) => {
        if (res.obj) {
          if (this.xzqhDefault === "320300") {
            this.xzqhArray = res.obj[0].xzqhs;
            this.items = { xzqh_code: "320300", xzqh_name: "不限" };
            this.xzqhArray.splice(0, 0, this.items);
          } else {
            res.obj.forEach((item) => {
              if (this.xzqhDefault === item.xzqh_code) {
                this.$set(this, "xzqhArray", [item]);
              }
            });
          }
        }
      });
    },
    setTab(type) {
      this.showPad = true;
      for (let key in this.tab) {
        if (type === key) {
          this.$set(this.tab, type, !this.tab[type]);
        } else {
          this.$set(this.tab, key, false);
        }
        if (this.tab[type]) {
          this.showCover = true;
        } else {
          this.showCover = false;
        }
      }
    },
    setVal(type, v, t, tab) {
      this.$set(this.formData, type, v);
      if (type === "totalPrice") {
        this.$set(this.formData, "zjgq", v.split("-")[0]);
        this.$set(this.formData, "zjgz", v.split("-")[1]);
        console.log(this.formData);
      } else if (type === "price") {
        this.$set(this.formData, "xsjgq", v.split("-")[0]);
        this.$set(this.formData, "xsjgz", v.split("-")[1]);
        console.log(this.formData);
      }
      if (tab) {
        this.$set(this.tab, tab, false);
        this.$set(this.tabText, tab, t);
        console.log(this.tabText);
        this.showCover = false;
      }
      /*this.currPageNo = 1;
      this.loading = false;
      this.finished = false;
      this.$set(this.formData, 'currPageNo', 1)
      this.list = [];*/
      this.getFirst();
    },

    setValB(type, v) {
      if (this.formData[type] === v) {
        this.$set(this.formData, type, "");
      } else {
        this.$set(this.formData, type, v);
      }
      /* this.currPageNo = 1;
      this.loading = false;
      this.finished = false;
      this.$set(this.formData, 'currPageNo', 1)
      this.list = [];*/
      // this.getFirst()
    },
    reset() {
      this.$set(this.formData, "lx", "");
      this.$set(this.formData, "liftMark", "");
      this.$set(this.formData, "houseAttribute", "");
      this.$set(this.formData, "structType", "");

      this.$set(this.tab, "showType", false);
      this.showCover = false;
      this.getFirst();
    },
    confirm() {
      this.$set(this.tab, "showType", false);
      this.showCover = false;
      this.getFirst();
    },
    // 价格判断
    priceConfirm() {
      if (this.min && this.max) {
        if (this.min > this.max) {
          if (this.priceType === 1) {
            this.$set(this.formData, "xsjgq", this.max);
            this.$set(this.formData, "xsjgz", this.min);
            this.min = this.formData.xsjgq;
            this.max = this.formData.xsjgz;
          } else {
            this.$set(this.formData, "zjgq", this.max * 10000);
            this.$set(this.formData, "zjgz", this.min * 10000);
            this.min = this.formData.zjgq / 10000;
            this.max = this.formData.zjgz / 10000;
          }
        } else {
          if (this.priceType === 1) {
            this.$set(this.formData, "xsjgz", this.max);
            this.$set(this.formData, "xsjgq", this.min);
            this.min = this.formData.xsjgq;
            this.max = this.formData.xsjgz;
          } else {
            this.$set(this.formData, "zjgz", this.max * 10000);
            this.$set(this.formData, "zjgq", this.min * 10000);
            this.min = this.formData.zjgq / 10000;
            this.max = this.formData.zjgz / 10000;
          }
        }
        /*this.currPageNo = 1;
        this.loading = false;
        this.finished = false;
        this.$set(this.formData, 'currPageNo', 1)
        this.list = [];*/
        if (this.priceType === 1) {
          this.$set(
            this.tabText,
            "showPrice",
            this.min + "-" + this.max + "万元"
          );
        } else {
          this.$set(
            this.tabText,
            "showPrice",
            this.min + "-" + this.max + "万元"
          );
        }
        this.getFirst();
      }
      this.$set(this.tab, "showPrice", false);
      this.showCover = false;
    },
    changePrice(type) {
      this.priceType = type;
    },
  },
};
</script>
<style lang="less" scoped>
.aside {
  position: fixed;
  top: 18vh;
  background-color: #fff;
  right: 0.23rem;
  padding: 0.16rem 0.23rem;
  text-align: center;
  line-height: 0.6rem;
  border-radius: 0.08rem;
  box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.3);
  p {
    color: #2f72f5;
  }
}
.pad_top {
  padding-top: 1.1rem;
}
.tab_con {
  padding: 0 0.16rem;
  font-size: 0.28rem;
  position: fixed;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e9e9e9;
  z-index: 2;
  background-color: #fff;
  &.fixed {
    position: fixed;
    top: 1.1rem;
    left: 0;
    right: 0;
    border-top: 1px solid #e9e9e9;
  }
  .inner_con {
    .text {
      padding: 0.2rem 0rem;
      text-align: center;
      width: 1.2rem;
      .van-icon {
        transition: all 0.3s;
        color: #cecece;
        transform: rotate(90deg);
        margin-left: 0.06rem;
        font-size: 0.2rem;
      }
      &.active {
        color: #2f72f5;
        .van-icon {
          transform: rotate(-90deg);
          color: #2f72f5;
        }
      }
    }
    .inner_form {
      background-color: #fff;
      position: absolute;
      left: 0;
      right: 0;
      top: calc(100% + 0.02rem);
      max-height: 7.12rem;
      overflow: auto;
    }
    .inner_list {
      padding: 0 0.5rem;
      p {
        line-height: 0.99rem;
        box-sizing: border-box;
        border-bottom: 1px solid #f4f4f4;
        text-align: center;
        &:last-child {
          border: none;
        }
        &.active {
          color: #2f72f5;
        }
      }
    }
    .price_list {
      .price_inner {
        height: 5.92rem;
      }
      .left {
        border-right: 1px solid #f4f4f4;
        width: 45%;
      }
      .right {
        box-sizing: border-box;
        padding-left: 0.2rem;
        max-height: 5.92rem;
        overflow: auto;
      }
      p {
        line-height: 0.99rem;
        box-sizing: border-box;
        border-bottom: 1px solid #f4f4f4;
        text-align: center;
        &:last-child {
          border: none;
        }
        &.active {
          color: #2f72f5;
        }
      }
    }
    .bottom_con {
      height: 1.2rem;
      box-sizing: border-box;
      border-top: 1px solid #f4f4f4;
      padding: 0 0.3rem;
      input {
        width: 1.38rem;
        height: 0.78rem;
        border: 1px solid #f4f4f4;
        text-align: center;
      }
      .tit {
        margin-right: 0.2rem;
      }
      i {
        margin: 0.1rem;
      }
      p {
        margin-left: 0.2rem;
      }
      .van-button {
        height: 0.78rem;
      }
    }
  }
}
.more_list {
  padding: 0 0.3rem 0;
  h4 {
    font-size: 0.3rem;
    margin-bottom: 0.3rem;
  }
  .more_con {
    padding-top: 0.46rem;
    height: 5.92rem;
    overflow: auto;
    box-sizing: border-box;
  }
  .btn_con {
    height: 1.2rem;
    box-sizing: border-box;
    border-top: 1px solid #f4f4f4;
    button {
      width: 3.3rem;
      line-height: 0.8rem;
      font-size: 0.28rem;
      border-radius: 0.02rem;
      &.reset {
        background-color: #eaf1ff;
        color: #2f72f5;
      }
      &.confirm {
        background-color: #2f72f5;
        color: #fff;
      }
    }
  }
  .row_con {
    margin-bottom: 0.54rem;
  }
  span {
    background-color: #f6f6f6;
    line-height: 0.66rem;
    width: 1.62rem;
    margin-right: 0.12rem;
    border-radius: 0.02rem;
    text-align: center;
    margin-bottom: 0.12rem;
    box-sizing: border-box;
    border: 1px solid #f6f6f6;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &.active {
      color: #2f72f5;
      background-color: #eaf1ff;
      border: 1px solid #2f72f5;
    }
  }
}
.bm-view {
  height: calc(100vh - 1.1rem);
  position: relative;
}
.map_bottom {
  position: absolute;
  z-index: 2;
  bottom: 0.4rem;
  width: 100%;
  .row {
    width: 7.14rem;
    margin: 0 auto;
    height: 2.1rem;
    border-radius: 0.08rem;
    box-shadow: 0 0 0.08rem rgba(0, 0, 0, 0.4);
    background-color: #fff;
    box-sizing: border-box;
    padding: 0.3rem;
    img {
      width: 2rem;
      height: 1.52rem;
    }
    .right {
      margin-left: 0.2rem;
      height: 1.52rem;
      width: 4.34rem;
      .tit {
        h5 {
          font-size: 0.3rem;
          width: 70%;
        }
        i {
          color: #2f72f5;
          font-size: 0.24rem;
          padding: 0.02rem 0.08rem;
          border: 1px solid currentColor;
        }
      }
      .address {
        color: #505050;
        font-size: 0.24rem;
      }
      .price {
        color: #ff4431;
        font-size: 0.22rem;
        span {
          font-size: 0.36rem;
          font-weight: 800;
        }
      }
    }
  }
}
.van-overlay {
  z-index: 3;
}
.select_con {
  position: fixed;
  top: calc(0.9rem);
  background-color: #fff;
  left: 0;
  right: 0;
  height: 60vh;
  overflow: auto;
  padding: 0.23rem;
  font-size: 0.26rem;
  z-index: 9;
  .row {
    height: 0.8rem;
    border-bottom: 1px solid #f5f5f5;
    p {
      font-size: #303030;
    }
    span,
    i {
      color: #a0a0a0;
      font-size: 0.24rem;
    }
  }
}
</style>